
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment'
import { AppConfig } from './app.config'
import { AppCountrySettings } from './app-country-settings.config'
import { AppOrganizationSettings } from './app-organization-settings.config'
import { AppLocalLabelsConfig } from './app-local-labels.config'
import { AppSettings } from './app-settings.config'
import { Observable, Subject, ReplaySubject, of, BehaviorSubject } from 'rxjs';
import { currencyOptionsDO } from '../core/multi-tenancy/services/multi-tenancy-config.service';

/**
 * This is a singleton class
 */
@Injectable({ providedIn: 'root' })
export class AppMetadataHandler {
    configDataJSON = {}
    entityCd = 'ProposalDO';
    //Provide all the Country Configs here
    public productCurrencyCd="MMK";
    public companyCurrencyCd="MMK";
    public currentCountryCd: string = 'HONGKONG';
    public currentCountryName: string = "INDIA"
    public currentCountryCdValue: string = 'INR';
    public currentOrganizationCd: string = environment['demo'] ? 'MMS' : 'MMS';

    public fetchTillUserHierarchyDataLevel = 99;
    // public basecurrency: string = "INR"
    public allowedcurrencies = ['INR', 'IDR', 'SGD', 'USD', 'HK$', 'THB']
    public baseCurrencyPREFIX: string = 'INR ';
    public baseCurrencyMiniPREFIX: string;
    public DECIMAL_SEPARATOR = "."
    public THOUSANDS_SEPARATOR = ","
    public baseCurrencySUFFIX = ''
    public currencyAlignment = 'left'
    public AEGISKEY = "AEGIS"
    public CGISSKEY = "CGISS"
    public INTEGRALKEY = "INTEGRAL"
    public ERRORVALUE = "ERROR"
    public MAXACQUISITIONANDCOMMISSIONERRORVALUE = "MAXACQUISITIONANDCOMMISSIONERROR"
    public defaultCurrencyOption : currencyOptionsDO = {
        prefix : "INR",
        thousands:  ".",
        decimal: ","
    }
    public refreshTransactionSpecificCurrency$ : BehaviorSubject<currencyOptionsDO> = new BehaviorSubject(this.defaultCurrencyOption)
    public defaultLanguage = 'EN'
    public supportedLanguages = [
        'EN',
        'ID',
    ]
    public entryViewModule = "New Business"
    public viewModuleEntity = "Policy"

    public LOB= environment['lob'] && environment['lob'].length > 0 ? environment['lob'].find(e => true) : environment['lob'];
    public SI_LABEL = this.LOB == 'LIFE' ? 'Sum Assured' : 'Sum Assured';
    public lifeLOB = this.LOB == 'HEALTH'? 'Life' : 'Life';

    public insuredLookupForNominee = {'insuredCd':[]};
    // public entryViewModule = "Policy Servicing"
    // public viewModuleEntity = "PolicyServicing"
    public allowedLOB = ['HEALTH','LIFE', 'MOTOR','TRAVEL','PROPERTY']    
    public EXTERNALUSERS = ['CLAIM_UNDERWRITING', 'CLAIM_REVIEW_MO', 'CLAIM_REVIEW_LEGAL', 'CLAIM_BRANCHINTIMATION']
    public UILABELCONSTANTS
    public showLanguageLabel = false;
    public localLocaleAllowed = false;
    public supportedBaseDOs = ['claimDO', 'policyDO', 'caseDO', 'investigationDO', 'adjudicationDO', 'intimationDO', 'policyServicingDO','proposalDO']
    public supportedRoleNodes = ['policyClientList', 'claimClientRoles', 'caseClients','proposalClients']
    public currentLobState = 'LIFE';
    // set global date format
    public GLOBAL_DATE_FORMAT_ANGULAR = "";
    public GLOBAL_DATE_FORMAT_MOMENT = "";
    public GLOBAL_DATE_FORMAT_WITHTIME = "DD MMM YYYY hh:mm:ss";
    public myIP = null;
    UIConfiguration = {};
    formItemsWithActionList = {};
    formItemsValueStoreForActionList = {};
    public exceptionMasterCache = [];
    public policyCurrencyCd=null;
    public currencyOptions = {
        prefix:"",
        thousands: this.THOUSANDS_SEPARATOR,
        decimal: this.DECIMAL_SEPARATOR,
        align: this.currencyAlignment
    }
    public supportedCurrencyMaster = {
        INR: {
            baseCurrencyPREFIX: "INR ",
            baseCurrencyMiniPREFIX: "Rs",
            DECIMAL_SEPARATOR: ".",
            THOUSANDS_SEPARATOR: ",",
            baseCurrencySUFFIX: ''
        },
        VND: {
            baseCurrencyPREFIX: "VND",
            baseCurrencyMiniPREFIX: "",
            DECIMAL_SEPARATOR: ",",
            THOUSANDS_SEPARATOR: ".",
            baseCurrencySUFFIX: ''
        },
        IDR: {
            baseCurrencyPREFIX: "IDR",
            baseCurrencyMiniPREFIX: "",
            DECIMAL_SEPARATOR: ",",
            THOUSANDS_SEPARATOR: ".",
            baseCurrencySUFFIX: ''
        },
        SGD: {
            baseCurrencyPREFIX: "SGD",
            baseCurrencyMiniPREFIX: "S$",
            DECIMAL_SEPARATOR: ".",
            THOUSANDS_SEPARATOR: ",",
            baseCurrencySUFFIX: ''
        },
        USD: {
            baseCurrencyPREFIX: "USD",
            baseCurrencyMiniPREFIX: "$",
            DECIMAL_SEPARATOR: ".",
            THOUSANDS_SEPARATOR: ",",
            baseCurrencySUFFIX: ''
        },
        HKD: {
            baseCurrencyPREFIX: "HKD",
            baseCurrencyMiniPREFIX: "HK$",
            DECIMAL_SEPARATOR: ".",
            THOUSANDS_SEPARATOR: ",",
            baseCurrencySUFFIX: ''
        },
        THB: {
            baseCurrencyPREFIX: "THB",
            baseCurrencyMiniPREFIX: "THB",
            DECIMAL_SEPARATOR: ".",
            THOUSANDS_SEPARATOR: ",",
            baseCurrencySUFFIX: ''
        },
        PHP: {
            baseCurrencyPREFIX: "PHP",
            baseCurrencyMiniPREFIX: "PHP",
            DECIMAL_SEPARATOR: ".",
            THOUSANDS_SEPARATOR: ",",
            baseCurrencySUFFIX: ''
        },
        MMK: {
            baseCurrencyPREFIX: "MMK",
            baseCurrencyMiniPREFIX: "K",
            DECIMAL_SEPARATOR: ".",
            THOUSANDS_SEPARATOR: ",",
            baseCurrencySUFFIX: ''
        },
        GBP: {
            baseCurrencyPREFIX: "GBP",
            baseCurrencyMiniPREFIX: "£",
            DECIMAL_SEPARATOR: ".",
            THOUSANDS_SEPARATOR: ",",
            baseCurrencySUFFIX: ''
        },
        CAD: {
            baseCurrencyPREFIX: "CAD",
            baseCurrencyMiniPREFIX: "CAD",
            DECIMAL_SEPARATOR: ".",
            THOUSANDS_SEPARATOR: ",",
            baseCurrencySUFFIX: ''
        }
    }
    setCurrency(currency='MMK'): Observable<boolean> {
        let currencyData: any = this.supportedCurrencyMaster[currency]
        if (currencyData) {
            this.baseCurrencyPREFIX = currencyData.baseCurrencyPREFIX
            this.baseCurrencyMiniPREFIX = currencyData.baseCurrencyMiniPREFIX
            this.DECIMAL_SEPARATOR = currencyData.DECIMAL_SEPARATOR
            this.THOUSANDS_SEPARATOR = currencyData.THOUSANDS_SEPARATOR
            this.baseCurrencySUFFIX = currencyData.baseCurrencySUFFIX
            console.info(`Currency Set as ${this.baseCurrencyPREFIX}`)
            return of(true)
        }
        else {
            return of(false)
        }
    }


    public preloadLookups = {
        "Claims": ['clmCauseOfDeathCd', 'clmEventTypeCd', 'identityTypeCd', 'docVisibilityCd', 'genderCd', 'productId', "addressTypeCd", 'corresStatusCd', 'intimationStatusCd', 'claimStatusCd','translationLanguageCd',
            'titleCd', "educationCd", 'manualAdjDecisionCd', 'paymentMethodCd', 'policyStatusCd', 'roleUsers', 'csrUsersUID', 'relationCd', 'claimRegRoleUsers', 'policyStageCd', 'premiumFrequencyCd', 'statCodeCd ', 'pstatCodeCd', 'statusCd', 'policyRoleCd', 'maritalStatusCd', 'checkListItemCd', 'occupationCd', 'educationTypeCd', 'courseCd', 'claimStageCd', 'requirements', 'userRequirements', 'citizenshipCd', 'sourcingChannelCd', 'investigationCategoryCd', 'investigationDetailCd', 'INVESTIGATIONSTATUS', 'premiumPaymentMethodCd', 'premiumStatusCd', 'userStatusCd', 'stateCd', 'clmPlaceOfDeathCd', 'requirementStatusCd',
            'booleanYNCd', 'investigationCategoryCd', 'investigationStatusCd', 'countryCd', 'illnessLevelCd', 'illnessCd','workQueueCd', 'contactPerson','ratingTypeCd','benefitOptionCd','claimConditionCd','zoneCd','reserveAmtReasonCd','claimReopenCd','claimProcessTypeCd','reportType','claimZoneCd'],
      

        "New Business": ['decisionCd', 'decisionTypeCd', 'manualUwDecisionCd','uwDecisionCd', 'uwRuleSubType', 'autoUwRuleCd', "UWRuleSubType", "productId", "loadingMethodCd", 'agentCategoryCd','policyRoleCd', 'translationLanguageCd',// Document Manager
            'agentDesignationCd', "agentStatusCd", "exclusionEventCd", "exclusionEventCategoryCd","serviceTaskTypeCd", "productType", "productPlanType", "productFamilyCd", "currencyCd", "roleUsers", "csrUsersUID", "claimRegRoleUsers",
            "documentCd", "requirementStatusCd", "docVisibilityCd", "waivedOffReasonCd", "requirements", "userRequirements", "relationCd", "genderCd", "citizenshipCd", "provinceCd", "cityCd", "identityCd","productCd", "productId",
            "purposeOfInsuranceCd", "clmEventTypeCd", "clientTypeCd" , "clmCauseOfDeathCd", "manualAdjDecisionCd", "paymentMethodCd", "policyStageCd", "policyStatusCd", "premiumStatusCd", "TypeofFund", "AccountPurpose",
        "masterReportNames","nbuReportNames","NBUChannelList", "coResponseCd", "ReasonForRejectedDecision","taskCd","channelCd","followupActions","occupationClassCd", "accountTypeCd","insuredRoleCd", "countryCd"],
      
            "Policy Servicing": ['genderCd']
    }

    public CurrencyMetaData = [
        {
            "currency": "AED",
            "prefix": "د.إ.‏",
            "postfix": ""
        },
        {
            "currency": "ARS",
            "prefix": "$",
            "postfix": "ARS"
        },
        {
            "currency": "AUD",
            "prefix": "$",
            "postfix": "AUD"
        },
        {
            "currency": "BRL",
            "prefix": "R$",
            "postfix": ""
        },
        {
            "currency": "CAD",
            "prefix": "$",
            "postfix": "CAD"
        },
        {
            "currency": "CHF",
            "prefix": "fr.",
            "postfix": ""
        },
        {
            "currency": "CNY",
            "prefix": "¥",
            "postfix": "CNY"
        },
        {
            "currency": "CZK",
            "prefix": "",
            "postfix": "Kč"
        },
        {
            "currency": "DKK",
            "prefix": "kr.",
            "postfix": "DKK"
        },
        {
            "currency": "EUR",
            "prefix": "",
            "postfix": "€"
        },
        {
            "currency": "GBP",
            "prefix": "£",
            "postfix": ""
        },
        {
            "currency": "HKD",
            "prefix": "HK$",
            "postfix": ""
        },
        {
            "currency": "HUF",
            "prefix": "",
            "postfix": "Ft"
        },
        {
            "currency": "IDR",
            "prefix": "Rp",
            "postfix": ""
        },
        {
            "currency": "ILS",
            "prefix": "₪",
            "postfix": ""
        },
        {
            "currency": "INR",
            "prefix": "रु",
            "postfix": ""
        },
        {
            "currency": "JPY",
            "prefix": "¥",
            "postfix": "JPY"
        },
        {
            "currency": "KRW",
            "prefix": "₩",
            "postfix": ""
        },
        {
            "currency": "MXN",
            "prefix": "$",
            "postfix": "MXN"
        },
        {
            "currency": "MYR",
            "prefix": "RM",
            "postfix": ""
        },
        {
            "currency": "NOK",
            "prefix": "kr",
            "postfix": "NOK"
        },
        {
            "currency": "NZD",
            "prefix": "$",
            "postfix": "NZD"
        },
        {
            "currency": "PHP",
            "prefix": "PhP",
            "postfix": ""
        },
        {
            "currency": "PLN",
            "prefix": "",
            "postfix": "zł"
        },
        {
            "currency": "RUB",
            "prefix": "",
            "postfix": "р."
        },
        {
            "currency": "SEK",
            "prefix": "SEK",
            "postfix": "kr"
        },
        {
            "currency": "SGD",
            "prefix": "$",
            "postfix": "SGD"
        },
        {
            "currency": "THB",
            "prefix": "฿",
            "postfix": ""
        },
        {
            "currency": "TRY",
            "prefix": "",
            "postfix": "TL"
        },
        {
            "currency": "TWD",
            "prefix": "NT$",
            "postfix": ""
        },
        {
            "currency": "UAH",
            "prefix": "",
            "postfix": "₴"
        },
        {
            "currency": "USD",
            "prefix": "$",
            "postfix": "USD"
        },
        {
            "currency": "VND",
            "prefix": "",
            "postfix": "₫"
        },
        {
            "currency": "ZAR",
            "prefix": "R",
            "postfix": ""
        }
    ]
    public GLOBAL_TIME_FORMAT_ANGULAR = "h:mm:ss";
    public APPCONSTANTS = {
        nbuDefaultState: "proposal_ManualUw",
        proposalType: "SINGLELIFE"
    }
    sortOrderLookups = ["userLevelCd"];


    public mockData = {
        workQueues: [
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569783445643,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "errorFl": false,
                "warningFl": null,
                "exceptionDOList": null,
                "id": 61,
                "queueCd": "CLM_INTIMATION",
                "managerId": "INT",
                "parentQueueCd": null,
                "icon": "border_color",
                "queueDesc": "Health Pending Cases",
                "objectName": "WorkQueueDO",
                "referenceNum": null
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569783445669,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "errorFl": false,
                "warningFl": null,
                "exceptionDOList": null,
                "id": 62,
                "queueCd": "CLM_INT_DEATH",
                "managerId": "INT",
                "parentQueueCd": "CLM_INTIMATION",
                "icon": "folder",
                "queueDesc": "Death intimation",
                "objectName": "WorkQueueDO",
                "referenceNum": null
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569783445696,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "errorFl": false,
                "warningFl": null,
                "exceptionDOList": null,
                "id": 63,
                "queueCd": "CLM_INT_HOSPITALISATION",
                "managerId": "INT",
                "parentQueueCd": "CLM_INTIMATION",
                "icon": "folder",
                "queueDesc": "Hospitalization intimation",
                "objectName": "WorkQueueDO",
                "referenceNum": null
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569783445728,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "errorFl": false,
                "warningFl": null,
                "exceptionDOList": null,
                "id": 64,
                "queueCd": "CLM_INT_CI",
                "managerId": "INT",
                "parentQueueCd": "CLM_INTIMATION",
                "icon": "folder",
                "queueDesc": "Critical illness intimation",
                "objectName": "WorkQueueDO",
                "referenceNum": null
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569783445756,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "errorFl": false,
                "warningFl": null,
                "exceptionDOList": null,
                "id": 65,
                "queueCd": "CLM_INT_ACCIDENT",
                "managerId": "INT",
                "parentQueueCd": "CLM_INTIMATION",
                "icon": "folder",
                "queueDesc": "Accident intimation",
                "objectName": "WorkQueueDO",
                "referenceNum": null
            }
        ],
        menu: [
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135118,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 1,
                "icon": "file-protect",
                "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "UW Workbench",
                "url": "/app/nbu/inbox/workbench",
                "sortOrder": 1,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135118,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 2,
                "icon": "file-sync",
                "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "Proposals",
                "url": "/app/nbu/proposal/search",
                "sortOrder": 2,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135118,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 3,
                "icon": "dashboard",
                "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "UW Dashboard",
                "url": "/app/nbu/proposal/uw-dashboard",
                "sortOrder": 3,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135118,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 3,
                "icon": "dashboard",
                "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "New Business Dashboard",
                "url": "/app/nbu/proposal/nb-dashboard",
                "sortOrder": 10,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135118,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 3,
                "icon": "dashboard",
                "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "FWA Dashboard",
                "url": "/app/nbu/proposal/fwa-dashboard",
                "sortOrder": 3,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135118,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 4,
                "icon": "dashboard",
                "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "SLA Dashboard",
                "url": "/app/nbu/proposal/sla-dashboard",
                "sortOrder": 3,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135241,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 5,
                "icon": "file-done",
                "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "Receipting And Accounting",
                "url": "/app/nbu/proposal/receipting",
                "sortOrder": 4,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135241,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 11,
                "icon": "file-pdf",
                "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "Reports",
                "url": "/app/nbu/proposal/report",
                "sortOrder": 8,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135241,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 11,
                "icon": "file-pdf",
                "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "Service Requests",
                "policyServingMenu" : true,
                "url": "/app/policyServicing/search-policy",
                "sortOrder": 8,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135241,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 11,
                "icon": "file-pdf",
                "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "Customer 360",
                "policyServingMenu" : true,
                "url": "/app/policyServicing/search-customer",
                "sortOrder": 8,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538136386,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 76,
                "icon": "logout",
                "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "Logout",
                "url": "/login",
                "sortOrder": 9,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135118,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 3,
                "icon": "dashboard",
                // "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "Uw Dashboard",
                "url": "/app/nbu/proposal/under-writer-dashboard",
                "sortOrder": 3,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135118,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 3,
                "icon": "upload",
                // "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "Bulk Upload",
                "url": "/app/nbu/proposal/bulkUpload",
                "sortOrder": 3,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135118,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 3,
                "icon": "upload",
                // "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "api-dashboard",
                "url": "/app/nbu/proposal/api-dashboard",
                "sortOrder": 3,
                "parentId": 0
            },
            {
                "parentObject": null,
                "versionId": 1,
                "guid": null,
                "createdDt": 1569538135118,
                "updatedDt": null,
                "createdUser": "AdminScript",
                "updatedUser": null,
                "baseCompanyCd": null,
                "id": 3,
                "icon": "upload",
                // "objectName": "RolePrivilegeMapDO",
                "referenceNum": null,
                "roleId": "CLAIM_INTIMATION",
                "privilegeCd": "IDP",
                "url": "/app/nbu/proposal/caseWithOCR",
                "sortOrder": 3,
                "parentId": 0
            },


        ],
        fetchTasksAssignedToUser: [
            {
                "guid": "c689b7a2-13cc-4708-86b8-6b9a5211135c",
                "id": 374,
                "proposalNum": null,
                "baseProductFamilyCd": null,
                "sumInsured": null,
                "finalPremiumAmt": null,
                "tripTypeCd": null,
                "tripRegionCd": null,
                "makeDesc": null,
                "modelName": null,
                "occupationCd": null,
                "constructionClassCd": null,
                "intimationNum": "INT0000034",
                "insuredName": "John Smith",
                "eventTypeCd": "Death",
                "eventDt": 1568678400000,
                "claimNum": "CLM0000022",
                "baseProductFamilyDesc": "Life",
                "baseProductCd": "StandardLife",
                "complexityScore": 10,
                "endDt": null,
                "entityGuid": "c689b7a2-13cc-4708-86b8-6b9a5211135c",
                "priority": null,
                "serviceTask": "claimRegistration",
                "taskDesc": "Claim registration",
                "startDt": 1569754034930,
                "status": "Pending",
                "taskUser": "DEEPALI",
                "lastReassignedBy": null,
                "workQueue": "HIGHV_DEATH_CLAIM",
                "levelEndTime": 1569878354000,
                "level": "LEVEL3",
                "warningFl": false,
                "pendingReqFl": false,
                "pendingTaskFl": false,
                "receivedDt": 0,
                "intimationDt": 1568851200000,
                "policyNum": "P00001"
            },
            {
                "guid": "0d791bb8-0337-4eda-a2d3-bab2b0d30c1f",
                "id": 390,
                "proposalNum": null,
                "baseProductFamilyCd": null,
                "sumInsured": null,
                "finalPremiumAmt": null,
                "tripTypeCd": null,
                "tripRegionCd": null,
                "makeDesc": null,
                "modelName": null,
                "occupationCd": null,
                "constructionClassCd": null,
                "intimationNum": "INT0000037",
                "insuredName": "John Smith",
                "eventTypeCd": "Death",
                "eventDt": 1569369600000,
                "claimNum": "CLM0000025",
                "baseProductFamilyDesc": "Life",
                "baseProductCd": "StandardLife",
                "complexityScore": 10,
                "endDt": null,
                "entityGuid": "0d791bb8-0337-4eda-a2d3-bab2b0d30c1f",
                "priority": null,
                "serviceTask": "claimRegistration",
                "taskDesc": "Claim registration",
                "startDt": 1569761897789,
                "status": "Pending",
                "taskUser": "DEEPALI",
                "lastReassignedBy": null,
                "workQueue": "HIGHV_DEATH_CLAIM",
                "levelEndTime": 1569920340000,
                "level": "LEVEL3",
                "warningFl": false,
                "pendingReqFl": true,
                "pendingTaskFl": false,
                "receivedDt": 0,
                "intimationDt": 1569542400000,
                "policyNum": "P00001"
            },
            {
                "guid": "d4c8b756-ed05-4ee2-820b-42f55327a161",
                "id": 392,
                "proposalNum": null,
                "baseProductFamilyCd": null,
                "sumInsured": null,
                "finalPremiumAmt": null,
                "tripTypeCd": null,
                "tripRegionCd": null,
                "makeDesc": null,
                "modelName": null,
                "occupationCd": null,
                "constructionClassCd": null,
                "intimationNum": "INT0000038",
                "insuredName": "John Smith",
                "eventTypeCd": "Death",
                "eventDt": 1568937600000,
                "claimNum": "CLM0000026",
                "baseProductFamilyDesc": "Life",
                "baseProductCd": "StandardLife",
                "complexityScore": 10,
                "endDt": null,
                "entityGuid": "d4c8b756-ed05-4ee2-820b-42f55327a161",
                "priority": null,
                "serviceTask": "claimRegistration",
                "taskDesc": "Claim registration",
                "startDt": 1569762083716,
                "status": "Pending",
                "taskUser": "DEEPALI",
                "lastReassignedBy": null,
                "workQueue": "HIGHV_DEATH_CLAIM",
                "levelEndTime": 1569920520000,
                "level": "LEVEL3",
                "warningFl": false,
                "pendingReqFl": false,
                "pendingTaskFl": false,
                "receivedDt": 0,
                "intimationDt": 1569542400000,
                "policyNum": "P00001"
            },
            {
                "guid": "23a89f59-21b9-49a1-b322-7a9f5d91c69c",
                "id": 298,
                "proposalNum": null,
                "baseProductFamilyCd": null,
                "sumInsured": null,
                "finalPremiumAmt": null,
                "tripTypeCd": null,
                "tripRegionCd": null,
                "makeDesc": null,
                "modelName": null,
                "occupationCd": null,
                "constructionClassCd": null,
                "intimationNum": "INT0000022",
                "insuredName": "John Smith",
                "eventTypeCd": "Death",
                "eventDt": 1568246400000,
                "claimNum": "CLM0000013",
                "baseProductFamilyDesc": "Life",
                "baseProductCd": "StandardLife",
                "complexityScore": 10,
                "endDt": null,
                "entityGuid": "23a89f59-21b9-49a1-b322-7a9f5d91c69c",
                "priority": null,
                "serviceTask": "claimAdjudication",
                "taskDesc": "Claim adjudication",
                "startDt": 1569571643126,
                "status": "Pending",
                "taskUser": "DEEPALI",
                "lastReassignedBy": "KUNAL",
                "workQueue": "HIGHV_DEATH_ADJUDICATION",
                "levelEndTime": 1569878354000,
                "level": "LEVEL3",
                "warningFl": false,
                "pendingReqFl": false,
                "pendingTaskFl": false,
                "receivedDt": 0,
                "intimationDt": 1569369600000,
                "policyNum": "P00001"
            },
            {
                "proposalNum": null,
                "baseProductFamilyCd": null,
                "sumInsured": null,
                "finalPremiumAmt": null,
                "tripTypeCd": null,
                "tripRegionCd": null,
                "makeDesc": null,
                "modelName": null,
                "occupationCd": null,
                "constructionClassCd": null,
                "guid": "435d5864-d8d1-46ed-8a4c-98a9bf3a3dee",
                "intimationNum": "INT0000032",
                "insuredName": "John Smith",
                "eventTypeCd": "Death",
                "eventDt": 1568160000000,
                "claimNum": "CLM0000021",
                "baseProductFamilyDesc": "Life",
                "baseProductCd": "StandardLife",
                "complexityScore": 10,
                "endDt": null,
                "entityGuid": "435d5864-d8d1-46ed-8a4c-98a9bf3a3dee",
                "priority": null,
                "serviceTask": "claimRegistration",
                "taskDesc": "Claim registration",
                "startDt": 1569750384145,
                "status": "Pending",
                "taskUser": "DEEPALI",
                "lastReassignedBy": null,
                "workQueue": "HIGHV_DEATH_CLAIM",
                "levelEndTime": 1569878354000,
                "level": "LEVEL3",
                "id": 371,
                "warningFl": false,
                "pendingReqFl": false,
                "pendingTaskFl": false,
                "receivedDt": 0,
                "intimationDt": 1568764800000,
                "policyNum": "P00001"
            },
            {
                "proposalNum": null,
                "baseProductFamilyCd": null,
                "sumInsured": null,
                "finalPremiumAmt": null,
                "tripTypeCd": null,
                "tripRegionCd": null,
                "makeDesc": null,
                "modelName": null,
                "occupationCd": null,
                "constructionClassCd": null,
                "guid": "5f258a6e-9ecd-489c-81e0-e447923243e0",
                "intimationNum": "INT0000035",
                "insuredName": "John Smith",
                "eventTypeCd": "Death",
                "eventDt": 1568246400000,
                "claimNum": "CLM0000023",
                "baseProductFamilyDesc": "Life",
                "baseProductCd": "StandardLife",
                "complexityScore": 10,
                "endDt": null,
                "entityGuid": "5f258a6e-9ecd-489c-81e0-e447923243e0",
                "priority": null,
                "serviceTask": "claimRegistration",
                "taskDesc": "Claim registration",
                "startDt": 1569754843200,
                "status": "Pending",
                "taskUser": "DEEPALI",
                "lastReassignedBy": null,
                "workQueue": "HIGHV_DEATH_CLAIM",
                "levelEndTime": 1569878354000,
                "level": "LEVEL3",
                "id": 376,
                "warningFl": false,
                "pendingReqFl": false,
                "pendingTaskFl": false,
                "receivedDt": 0,
                "intimationDt": 1569369600000,
                "policyNum": "P00001"
            }
        ]
    }

    public featureFlags = {
        enableDemoClaimsUI: false,
        enablePaginationOnInbox: true,
        enableStaticComponents: true,
        enableStaticTabs: true,
        menuIndentation: true,
        blockSaveForOtherUsers : true,
        setDOAsClaimDOIfNoDOMappingFound: true,
        enableHospitalTabInAllTransaction: false,
        enablePoliceDetails: false,
        enableTransformLogForSteps: true,
        enableMarkAllRequirementsAsReceived: false,
        enableMarkAllChecklistAsCompleted: true,
        enableSeparateAPICallsForWorflowAuditForIntimationAndClaims: false,
        changeURLOfClaimIntimation: false,
        multiCaptureBankDetails: true,
        enableClientValidationHandlingOnTransform: true,
        enableNotification: false,
        enableChat: false,
        enableCacheEmptyLookups: false,
        enableAutoInitializeTransformDataPipe: true,
        enableUsageOfDataTransformService: true,
        allowEmptyReqEntityGuid: true,
        transformValidatorAfterZip: true,
        redirectOnServerErrors: environment.globalErrorRouting,
        iconPrefetch: false,
        enableInterfaceEndpoints: environment.enableInterfaceEndpoints,
        includeEntityDocumentDOsInTransform: false,
        enableExtractionOfInsuredFromProposalIO: true,
        enableAPIMapper: false,
        sendProposalDOsInTransaction: false,
        sendClaimProposalDOInTransaction: true,
        enableMockHealthIO: false,
        showOtherPoliciesGrid: true,
        demoChange: true,
        ExtractEmittedClientWithExtraLoop: true,
        _CustomAddNomineeFetchedFromPolicyWhenTabNotVisible: true,
        enableBetaFeatures: false,
        enableSingleDecisionOnDecisionBreakup: false,
        enableGenericQuestionnaire: true,
        waitForLabelsAfterLogin: false,
        enableDynamicRendering: false,
        showPolicyServingMenu : false,
        showCoveragesInPanelDesign: true,
        showDynamicLabReportsData: true,
        enableDataEntryMode: true,
        enableOCRVerificationInDocumentManager: true,
        enableSplitPreview: true,
        enableRiskSummarization : true,
        BSLI_Config : true,
        _CustomCopyPaymentFrqueuencyCdFromClaimPaymentDOToClaimPolicy: false,
        _CustomCopySplitPercentageFromClaimClientToClaimPaymentDO: true,
        _CustomCodeToMoveInsuredtoZerothPosition: true,
        addPayeeOnTransaction : true,
        PMLI_Config:true,
        _CustomSetWopCdBasedOnWopFl: true,
        _normalizeSelectClientDataIfGuidIsNullified: true,
        enableDummyRules:true,   
        enableBuildExpressionValidations: true,
        "MaxLengthValue": 500
    }

    isStable = true

    splitCamelCaseExclusionOfWords = ['Cd']
    splitCamelCaseReplacements = [{
        code: 'Num',
        replacement: 'Number'
    },
    {
        code: 'Cd',
        replacement: ''
    },
    {
        code: 'Dt',
        replacement: 'Date'
    }]

    public claimsModes = {
        claimantMode: 'SINGLE',
        nomineeMode: 'MULTI'
    }

    public transactionRibbonMetaData = {
        claimIntimation: [

            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "clmIntimationNum",
                "description": "Intimation Number",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "Insured",
                "description": "Insured Name",
                "isVisible": true,
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true,
            }
        ],
        proposal_ManualUw: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false
            },
            {
                "key": "statusCd",
                "description": "Proposal Status",
                "isVisible": true,
                "lookup": "policyStatusCd"
            },
            {
                "key": "commencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "expiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true
            },
            {
                "key": "sumInsuredAmt",
                //"description": this.SI_LABEL,
                "description": "Sum Assured",
                "formatter": true,
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true
            }
        ],
        REFERRALS: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false
            },
            {
                "key": "statusCd",
                "description": "Proposal Status",
                "isVisible": true,
                "lookup": "policyStatusCd"
            },
            {
                "key": "commencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "expiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true
            },
            {
                "key": "sumInsuredAmt",
                //"description": this.SI_LABEL,
                "description": "Sum Assured",
                "formatter": true,
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true
            }
        ],
        claimRegistration: [

            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "claimNum",
                "description": "Claim Number",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "Insured",
                "description": "Insured Name",
                "isVisible": true,
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            }
        ],
        claimAdjudication: [

            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "clmIntimationNum",
                "description": "Claim Number",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "Insured",
                "description": "Insured Name",
                "isVisible": true,
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            }
        ],
        claimInvestigation: [

            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "clmIntimationNum",
                "description": "Claim Number",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "Insured",
                "description": "Insured Name",
                "isVisible": true,
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            }
        ],
        claimPayout: [

            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "clmIntimationNum",
                "description": "Claim Number",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "Insured",
                "description": "Insured Name",
                "isVisible": true,
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true,
            }
        ],
        claimUWReferral: [

            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "clmIntimationNum",
                "description": "Claim Number",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "Insured",
                "description": "Insured Name",
                "isVisible": true,
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            }
        ],
        claimHOReferralWaiver: [

            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "clmIntimationNum",
                "description": "Claim Number",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "Insured",
                "description": "Insured Name",
                "isVisible": true,
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            }
        ],
        claimHOReferralOpinion: [

            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "clmIntimationNum",
                "description": "Claim Number",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "Insured",
                "description": "Insured Name",
                "isVisible": true,
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            }
        ],
        claimsCommitteeReferral: [

            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "clmIntimationNum",
                "description": "Claim Number",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "Insured",
                "description": "Insured Name",
                "isVisible": true,
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            }
        ],
        claimReinsReferral: [

            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "clmIntimationNum",
                "description": "Claim Number",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "Insured",
                "description": "Insured Name",
                "isVisible": true,
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            }
        ],
        proposal_DataEntry: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false
            },
            {
                "key": "statusCd",
                "description": "Proposal Status",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "expiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true
            },
            {
                "key": "sumInsuredAmt",
                //"description": this.SI_LABEL,
                "description": "Sum Assured",
                "formatter": true,
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true
            }
        ],
        policyAutoUWTask: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false
            },
            {
                "key": "statusCd",
                "description": "Proposal Status",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "expiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true
            },
            {
                "key": "sumInsuredAmt",
                //"description": this.SI_LABEL,
                "description": "Sum Assured",
                "formatter": true,
                "pipe": 'CurrencyFormatter',
                "isVisible": true
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true
            }
        ],
        LIFEproposal_DataEntry: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false
            },
            {
                "key": "statusCd",
                "description": "Status",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "expiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true
            },
            {
                "key": "sumInsuredAmt",
                "description": this.SI_LABEL,
                "formatter": true,
                "isVisible": true
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true
            }
        ],
        LIFEproposal_ManualUw: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false
            },
            {
                "key": "statusCd",
                "description": "Proposal Status",
                "isVisible": true,
                "lookup": "policyStatusCd"
            },
            {
                "key": "commencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "expiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true
            },
            {
                "key": "sumInsuredAmt",
                //"description": this.SI_LABEL,
                "description": "Sum Assured",
                "formatter": true,
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true
            }
        ],
        PROPERTYproposal_DataEntry: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false
            },
            {
                "key": "statusCd",
                "description": "Status",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "expiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true
            },
            {
                "key": "sumInsuredAmt",
                "description": this.SI_LABEL,
                "formatter": true,
                "isVisible": true
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true
            }
        ],
        TRAVELproposal_DataEntry: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false
            },
            {
                "key": "statusCd",
                "description": "Status",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "expiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true
            },
            {
                "key": "sumInsuredAmt",
                "description": this.SI_LABEL,
                "formatter": true,
                "isVisible": true
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true
            }
        ],
        MOTORproposal_DataEntry: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false
            },
            {
                "key": "statusCd",
                "description": "Status",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "expiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true
            },
            {
                "key": "sumInsuredAmt",
                "description": this.SI_LABEL,
                "formatter": true,
                "isVisible": true
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true
            }
        ],
        proposal_CounterOffer: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false
            },
            {
                "key": "statusCd",
                "description": "Proposal Status",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "expiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true
            },
            {
                "key": "sumInsuredAmt",
                //"description": this.SI_LABEL,
                "description": "Sum Assured",
                "formatter": true,
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true
            }
        ],
        LIFEproposal_CounterOffer: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false
            },
            {
                "key": "statusCd",
                "description": "Proposal Status",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "expiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true
            },
            {
                "key": "sumInsuredAmt",
                //"description": this.SI_LABEL,
                "description": "Sum Assured",
                "formatter": true,
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true
            }
        ],
        policyServicingTask: [
            {
                "key": "proposalNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "insuredName",
                "description": "Insured Name",
                "isVisible": true
            },
            {
                "key": "policyStartDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "policyCover",
                "description": "Policy Cover",
                "isVisible": true
            },
            {
                "key": "policyStatus",
                "description": "Policy Status",
                "isVisible": true
            },
            {
                "key": "premiumStatus",
                "description": "Premium Status",
                "formatter": true,
                "isVisible": true
            }
        ],
        policyServicingCustomerTask: [
            {
                "key": "proposalNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "stageCd",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "statusCd",
                "description": "Insured Name",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true
            },
            {
                "key": "expiryDt",
                "description": "Policy Cover",
                "isVisible": true
            },
            {
                "key": "baseProductCd",
                "description": "Policy Status",
                "isVisible": true
            },
            {
                "key": "sumInsuredAmt",
                "description": "Premium Status",
                "formatter": true,
                "isVisible": true
            }
        ],
        default: [

            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "clmIntimationNum",
                "description": "Claim Number",
                "isVisible": true
            },
            {
                "key": "commencementDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "Insured",
                "description": "Insured Name",
                "isVisible": true,
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true,
                "pipe": 'CurrencyFormatter'
            }
        ]
    }

    public inboxCardMetaData = {
        claimIntimation: [
            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "policyOwner",
                "description": "Policy Owner",
                "isVisible": false
            }, {
                "key": "intimationNum",
                "description": "Intimation Number",
                "isVisible": true
            },
            {
                "key": "policyCommenceDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "insuredName",
                "description": "Insured Name",
                "isVisible": true
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true
            }
        ],
        proposal_DataEntry: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe" : "",
                "ignoreTechnicalTranslate" : true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe" : "technicalTranslate"
            },
            {
                "key": "statusCd",
                "description": "Status",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'technicalTranslate'
            },
            {
                "key": "policyCommencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'date'
            },
            {
                "key": "policyExpiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'date'
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'technicalTranslate'
            },
            {
                "key": "sumInsuredAmt",
                "description": this.SI_LABEL,
                "formatter": true,
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'technicalTranslate'
            }
        ],
        proposal_ManualUw: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe" : "",
                "ignoreTechnicalTranslate" : true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false,
                "isSelected" : false,
                 "searchFilter": true,
                "sortFilter": true,
                "pipe": 'technicalTranslate'
            },
            {
                "key": "statusCd",
                "description": "Status",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'technicalTranslate'
            },
            {
                "key": "policyCommencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'date'
            },
            {
                "key": "policyExpiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'date'
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'technicalTranslate'
            },
            {
                "key": "sumInsuredAmt",
                "description": this.SI_LABEL,
                "formatter": true,
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'CurrencyFormatter'
            }
        ],
        REFERRALS: [
            {
                "key": "proposalNum",
                "description": "Proposal Number",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe" : "",
                "ignoreTechnicalTranslate" : true
            },
            {
                "key": "stageCd",
                "description": "Workflow Stage",
                "isVisible": false,
                "isSelected" : false,
                 "searchFilter": true,
                "sortFilter": true,
                "pipe": 'technicalTranslate'
            },
            {
                "key": "statusCd",
                "description": "Status",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'technicalTranslate'
            },
            {
                "key": "policyCommencementDt",
                "description": "Policy Start Date",
                "date": true,
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'date'
            },
            {
                "key": "policyExpiryDt",
                "description": "Policy Expiry Date",
                "date": true,
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'date'
            },
            {
                "key": "baseProductCd",
                "description": "Product",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'technicalTranslate'
            },
            {
                "key": "sumInsuredAmt",
                "description": this.SI_LABEL,
                "formatter": true,
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "finalPremiumAmt",
                "description": "Premium",
                "formatter": true,
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'CurrencyFormatter'
            },
            {
                "key": "premiumStatusCd",
                "description": "Premium Status",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'CurrencyFormatter'
            }
        ],
        default: [
            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "policyOwner",
                "description": "Policy Owner",
                "isVisible": false
            }, {
                "key": "intimationNum",
                "description": "Intimation Number",
                "isVisible": true
            },
            {
                "key": "startDt",
                "description": "Policy Commencement",
                "date": true,
                "isVisible": true
            },
            {
                "key": "insuredName",
                "description": "Insured Name",
                "isVisible": true
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true
            }
        ]
    }

    public inboxCardMetaDataSuperSet = {
        claimIntimation: [
            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "policyOwner",
                "description": "Policy Owner",
                "isVisible": false
            }, {
                "key": "intimationNum",
                "description": "Intimation Number",
                "isVisible": true
            },
            {
                "key": "policyCommenceDt",
                "description": "Policy Commencement",
                "isVisible": true
            },
            {
                "key": "insuredName",
                "description": "Insured Name",
                "isVisible": true
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true
            }
        ],
        proposal_DataEntry: [
            {
                "key": "currencyCd",
                "formatter": false,
                "description": "Currency",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "ignoreTechnicalTranslate" : true
            },
            {
                "key": "levelEndTime",
                "formatter": false,
                "date": false,
                "dateTime" :true,
                "description": "SLA End Time",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'date'
            },
            {
                "key": "submissionModeCd",
                "description": "Source",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true
            }
        ],
        proposal_ManualUw: [
            {
                "key": "currencyCd",
                "formatter": false,
                "description": "Currency",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "ignoreTechnicalTranslate" : true
            },
            {
                "key": "levelEndTime",
                "formatter": false,
                "date": false,
                "dateTime" :true,
                "description": "SLA End Time",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'date'
            },
            {
                "key": "submissionModeCd",
                "description": "Source",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true
            }
        ],
        REFERRALS: [
            {
                "key": "currencyCd",
                "formatter": false,
                "description": "Currency",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "ignoreTechnicalTranslate" : true
            },
            {
                "key": "levelEndTime",
                "formatter": false,
                "date": false,
                "dateTime" :true,
                "description": "SLA End Time",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true,
                "pipe": 'date'
            },
            {
                "key": "submissionModeCd",
                "description": "Source",
                "isVisible": true,
                "isSelected" : false,
                "searchFilter": true,
                "sortFilter": true
            }
        ],
        default: [
            {
                "key": "policyNum",
                "description": "Policy Number",
                "isVisible": true
            },
            {
                "key": "policyOwner",
                "description": "Policy Owner",
                "isVisible": false
            }, {
                "key": "intimationNum",
                "description": "Intimation Number",
                "isVisible": true
            },
            {
                "key": "startDt",
                "description": "Policy Commencement",
                "date": true,
                "isVisible": true
            },
            {
                "key": "insuredName",
                "description": "Insured Name",
                "isVisible": true
            },
            {
                "key": "claimedAmt",
                "description": "Claimed Amount",
                "isVisible": true
            }
        ]
    }



    constructor(
        private appConfig?: AppConfig,
        private appSettings?: AppSettings,
        private appCountrySettings?: AppCountrySettings,
        private appOrganizationSettings?: AppOrganizationSettings,
        private AppLocalLabelsConfig?: AppLocalLabelsConfig
    ) {
    }

    ngOnInit() {

    }

    initializeConfig() {
        let caller: Subject<any> = new Subject<any>();
        //push values
        this.appCountrySettings.currentCountryCd = this.currentCountryCd;
        this.appCountrySettings.currentCountryCdValue = this.currentCountryCdValue;
        this.appCountrySettings.currentCountryName = this.currentCountryName
        this.appOrganizationSettings.currentOrganizationCd = this.currentOrganizationCd;

        //pull values
        this.UILABELCONSTANTS = this.AppLocalLabelsConfig.UILABELCONSTANTSv1
        caller.next({ status: true });
        return caller;
    }

    getAllMetaData() {

    }

    getEntryPoint(roleCd?) {
        let matchingModules = this.appSettings.entryPoints.filter(entryPoint => {
            return entryPoint.viewModule == this.entryViewModule && entryPoint.roleCd == roleCd
        })
        if (matchingModules.length == 0) {
            matchingModules = this.appSettings.entryPoints.filter(entryPoint => {
                return entryPoint.viewModule == this.entryViewModule && entryPoint.roleCd == 'default'
            })
        }
        if (matchingModules.length > 0) {
            return matchingModules[0].entryPoint
        }
        else
            return "404"
    }

    isReadOnly : boolean = false;

}
